import { render, staticRenderFns } from "./staffSelector.vue?vue&type=template&id=d4f65dbe&scoped=true&"
import script from "./staffSelector.vue?vue&type=script&lang=js&"
export * from "./staffSelector.vue?vue&type=script&lang=js&"
import style0 from "./staffSelector.vue?vue&type=style&index=0&id=d4f65dbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4f65dbe",
  null
  
)

export default component.exports